export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnOffWhite',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                headerSize: 'large',
                header1: 'Support',
                text1: 'We\'re reworking the support pages so bear with us. In the meantime please have a look at the information below.' 
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'General',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                text1: '<strong>FAQ</strong>',
                text2: 'You can find the answers to the most common (non-technical) questions <a href="/FAQ" style="text-decoration:underline; color:#0048FF;">in our FAQ</a>.'
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            // top: {
            //   component: 'flex-block',
            //   data: {
            //     blockModifiers: ['endMargin'],
            //     text1: 'FAQ',
            //     text2: 'You can find the answers to the most common (non-technical) questions <a href="/FAQ" style="text-decoration:underline; color:#0048FF;">in our FAQ</a>.'
            //   }
            // },
            blockModifiers: ['noPadding'],
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                text1: '<strong>Order</strong>',
                text2: 'For any questions regarding your order, shipping, delivery or returns please contact the selling party immediately. Spotin is the technology solution enabling the sale and are mediating your order to the seller(s). Spotin does not sell or send any products.'
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                text1: '<strong>Terms & conditions</strong>',
                text2: 'Looking for <a href="/terms" style="text-decoration:underline; color:#0048FF;">Spotin\'s Terms & Conditions</a>?'
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'offBlackOnSand',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            // top: {
            //   component: 'flex-block',
            //   data: {
            //     blockModifiers: ['endMargin'],
            //     text1: 'Sell with Spotin?',
            //     text2: '<p>1. Get in contact either witht the \'Get started\'-button above or contact <a href="mailto: sales@spotin.com" style="text-decoration:underline; color:#0048FF;">sales@spotin.com</a>.</p><p>2. Review and sign seller agreement.</p><p>3. Provide the basic information we need to get you started with the <a href="/newcustomer" style="text-decoration:underline; color:#0048FF;"> new customer form</a>.</p>'
            //   }
            // },
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                text1: '<strong>Payment methods</strong>',
                text2: 'Spotin has a range of payment options included out of the box with partnering payment suppliers. Spotin currently offers the following payment options: card payments (Visa, Mastercard), Apple Pay, Google Pay, invoice in partnership with Stripe and Klarna.<br><br>New payment options and payment suppliers are added regularly. Payment solutions can be selected depending on market.'
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                text1: '<strong>Contact</strong>',
                text2: `
                  <p><div style="border: none; background-color: #FEF2CD; color: #86680F; font-size: 14px; padding: 15px; border-radius: 10px; margin-top: 10px; width: fit-content !important;"><strong>Order related questions?</strong><br>Please see the <a style="text-decoration: underline;" href="/ordersupport">order support page</a></div></p>
                  <br>
                  <p>For selling/using Spotin contact <a href="mailto:sales@spotin.com" style="text-decoration:underline; color:#0048FF;">sales@spotin.com</a></p>
                  <p>For PR/marketing related inquiries contact <a href="mailto:marketing@spotin.com" style="text-decoration:underline; color:#0048FF;">marketing@spotin.com</a></p>
                  `
              }
            },
          }
        ]
      },
    },


    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnBlue',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                header1: 'Developer',
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                text1: '<strong>Spotin API</strong>',
                text2: 'Spotin API documentation can be found at <a href="https://developers.spotin.com" style="text-decoration:underline; color:#fff;">developers.spotin.com</a>'
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnBlue',
        blockModifiers: ['noPaddingTop'],
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                // blockModifiers: ['endMargin'],
                text1: '<strong>Supported platforms</strong>',
                text2: '<p>Spotin support\'s a range of platforms out of the box. Shopify, Magento, WooCommerce, Salesforce Commerce Cloud, Centra, CVS-file imports, Google feeds, or order mangement directly via email.</p><p>Contact <a href="mailto:sales@spotin.com"  style="text-decoration:underline; color:#fff;">sales@spotin.com</a> to know more.</p>' 
              }
            },
            bottom: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin'],
                text1: '<strong>Contact</strong>',
                text2: 'You can reach Spotin\'s integration team at <a href="mailto:integration@spotin.com" style="text-decoration:underline; color:#fff;">integration@spotin.com</a>'
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnOffBlack',
        sections: [
          {
            top: {
              component: 'flex-block',
              data: {
                header1: 'Commonly asked for'
              }
            },
            bottom: {
              component: 'Related',
              data: {
                buttons: [
                  {
                    icon: 'arrowUpRight',
                    label: '<strong>FAQ</strong>',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'faq',
                  },
                  {
                    icon: 'arrowUpRight',
                    label: '<strong>Spotin Terms & Conditions</strong>',
                    blockModifiers: ['alignLabelLeft', 'alignLabelTop'],
                    path: 'terms',
                  }
                ],
              }
            }
          }
        ]
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./pages/Support.js